import { apiService } from "@/lib/api";

const BASE_URL = "/api/v2/shift-timing";

export const ShiftTimingService = {
  async list(params = {}) {
    const response = await apiService.getSecure(`${BASE_URL}/list`, {
      params: {
        ...(params.is_active !== undefined ? { is_active: params.is_active } : {}),
      },
    });
    return response.data;
  },

  async getById(shiftId) {
    const response = await apiService.getSecure(`${BASE_URL}/get/${shiftId}`);
    return response.data;
  },

  async create(payload) {
    const response = await apiService.postSecure(`${BASE_URL}/create`, payload);
    return response.data;
  },

  async update(shiftId, payload) {
    const response = await apiService.patch(`${BASE_URL}/update/${shiftId}`, payload);
    return response.data;
  },
};

export default ShiftTimingService;
